import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../context/AuthProvider';
import { homeFor } from '../utils/access';

/**
 * Guarda de un área privada entera.
 *
 * Las tres áreas repetían el mismo bloque: esperar a que el servidor confirme
 * la sesión, mandar al login conservando el destino si no hay ninguna, y si la
 * hay pero no da acceso, llevar a donde esa persona sí puede trabajar.
 */
export default function AreaGuard({ allowed, children }) {
    const { user, sessionReady } = useAuthContext();
    const location = useLocation();

    // Los permisos guardados en localStorage pueden estar caducados (un cambio
    // de rol, un catálogo distinto). Hasta que el servidor confirme la sesión
    // no se expulsa a nadie: si no, recargar dentro de una ruta protegida
    // echaba fuera a quien sí tenía acceso.
    if (!sessionReady) return null;

    if (allowed(user)) return children;

    if (!user) {
        const intended = location.pathname + location.search;

        return (
            <Navigate
                to={`/login?next=${encodeURIComponent(intended)}`}
                state={{ from: intended }}
                replace
            />
        );
    }

    return <Navigate to={homeFor(user)} replace />;
}
